import React from 'react';
import moment from 'moment';
import SectionCard from 'components/organisms/section_card';

const AndamentosSection = ({ data }: any) => {
  if (!data?.length) return null;

  return (
    <SectionCard title="Andamentos da licitação" icon="description">
      <div className="timeline">
        {data.map((item: any) => (
          <div key={item.id} className="timeline-item">
            <div className="timeline-date">
              {moment(item?.deadline).format('DD/MM/YYYY, HH:mm')}
            </div>
            <div className="timeline-content">{item.title}</div>
          </div>
        ))}
      </div>
    </SectionCard>
  );
};

export default AndamentosSection;
